var Backbone = require('backbone');

var UISettings = Backbone.Model.extend({
  defaults: {
    showLegends: true,
    showLayerSelector: false
  }
});

module.exports = UISettings;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/vis/settings.js
// module id = 1695
// module chunks = 6